(function() {
  var video = document.getElementById('tpl-hero-video');
  if (video && video.dataset.posterLg && window.innerWidth >= 750) {
    video.poster = video.dataset.posterLg;
  }

  /* Deferred hero video start — attach <source> and play ~700ms after
     first paint. The poster stays visible the whole time so users see
     a still image that "comes alive" rather than a loading state.
     Saves ~12s of LCP starvation on 4G. Respects reduced-motion. */
  /* Pick the right MP4 for this viewport. Browser's <source media> attribute
     is unreliable for <video> across Safari/Firefox, so we resolve in JS at
     attach time. Falls back to whichever URL is set if the other is blank. */
  function pickHeroSrc() {
    var isMobile = window.innerWidth < 750;
    var desktop = video.dataset.autoplaySrcDesktop || '';
    var mobile = video.dataset.autoplaySrcMobile || '';
    if (isMobile) return mobile || desktop;
    return desktop || mobile;
  }

  /* Pre-buffer the video DURING the splash so it plays instantly when
     splash dismisses. Attaches the <source>, sets preload="auto", and
     calls .load() — but does NOT call .play() yet. By the time splash
     fades (~4s later), the browser has buffered enough to play
     immediately. Without this, the video doesn't start downloading
     until splash is gone, leaving a 1–3s blank window on slow networks. */
  function preloadHeroVideo() {
    if (!video) return;
    if (video.dataset.autoplaySourceAttached === '1') return;
    var srcUrl = pickHeroSrc();
    if (!srcUrl) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    video.dataset.autoplaySourceAttached = '1';

    /* iOS Safari: muted/playsinline must be on the element BEFORE
       load() / play() — HTML attributes alone aren't always enough.   */
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';

    if (!video.querySelector('source')) {
      var src = document.createElement('source');
      src.src = srcUrl;
      if (video.dataset.autoplayType) src.type = video.dataset.autoplayType;
      video.appendChild(src);
      video.load();
    }
  }

  function startHeroVideo() {
    if (!video) return;
    if (video.dataset.autoplayStarted === '1') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    preloadHeroVideo(); /* ensure source attached if not already */
    if (!pickHeroSrc()) return;
    video.dataset.autoplayStarted = '1';

    var attemptPlay = function () {
      var p = video.play();
      if (p && p.then) {
        p.catch(function () {
          /* Autoplay blocked. Fall back to: start on first user gesture
             (tap, scroll, key). Keeps the toggle button working too.   */
          var resume = function () {
            video.play().catch(function () { /* still blocked; user can tap toggle */ });
            ['touchstart','click','keydown','scroll'].forEach(function(ev){
              document.removeEventListener(ev, resume, { passive: true });
            });
          };
          ['touchstart','click','keydown','scroll'].forEach(function(ev){
            document.addEventListener(ev, resume, { passive: true, once: true });
          });
        });
      }
    };
    attemptPlay();
  }

  /* Splash coordination — when the homepage splash is showing:
       (a) start buffering the MP4 immediately (during splash) so it's
           ready to play the moment splash exits.
       (b) call .play() when splash dispatches `tpl-splash-done`.
     On non-splash pages, just start on idle as before.                  */
  function bindHeroVideoStart() {
    /* TPL patch 2026-07-10 (audit P0-2): honor Save-Data / 2G — poster only. */
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

    var splashEl = document.getElementById('tpl-splash') || document.getElementById('tpl-tm-splash'); /* Paris or Table Manners splash */
    var splashDone = (window.tplSplash && window.tplSplash.done) || !splashEl;
    if (splashDone) {
      /* TPL patch 2026-07-10 (audit P0-2): the fetch used to start at idle
         ~600ms after DOMContentLoaded, competing with LCP images on 4G
         (Lighthouse mobile LCP hit 25s). Wait for window.load so the MP4
         downloads only after the critical path; the poster carries LCP. */
      var begin = function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(startHeroVideo, { timeout: 2500 });
        } else {
          setTimeout(startHeroVideo, 1000);
        }
      };
      if (document.readyState === 'complete') {
        begin();
      } else {
        window.addEventListener('load', begin, { once: true });
      }
    } else {
      /* Pre-buffer immediately, but wait one frame so the splash gets
         its first paint without the video stealing bandwidth from the
         critical-path text. ~16ms is enough for splash to render.      */
      requestAnimationFrame(function(){
        requestAnimationFrame(preloadHeroVideo);
      });
      document.addEventListener('tpl-splash-done', function () {
        startHeroVideo();
      }, { once: true });
    }
  }
  if (video && (video.dataset.autoplaySrcDesktop || video.dataset.autoplaySrcMobile)) {
    bindHeroVideoStart();
  }

  var btn = document.getElementById('tpl-hero-video-toggle');
  if (!btn || !video) return;
  var pauseIcon = btn.querySelector('.tpl-hero__video-icon--pause');
  var playIcon = btn.querySelector('.tpl-hero__video-icon--play');
  btn.addEventListener('click', function() {
    if (video.paused) {
      /* Cold-start path if user taps before idle timer fires. */
      startHeroVideo();
      video.play();
      pauseIcon.style.display = '';
      playIcon.style.display = 'none';
      btn.setAttribute('aria-label', 'Pause background video');
    } else {
      video.pause();
      pauseIcon.style.display = 'none';
      playIcon.style.display = '';
      btn.setAttribute('aria-label', 'Play background video');
    }
  });
})();

/* ─── Cuepoint Overlays ───
   Time-based overlay swap. Each cuepoint has data-start/data-end (seconds).
   Multiple cuepoints can be active simultaneously (rare — usually one at a
   time). CSS transition on .is-active handles the crossfade duration set by
   --tpl-cuepoint-fade. On video loop (timeupdate goes 19 → 0), the earlier
   cuepoint re-activates automatically via the same range check.
   Respects prefers-reduced-motion: skips transition, first cuepoint pinned. */
(function () {
  var video = document.getElementById('tpl-hero-video');
  var container = document.querySelector('[data-cuepoints]');
  if (!video || !container) return;

  var cuepoints = Array.prototype.slice.call(
    container.querySelectorAll('[data-cuepoint]')
  ).map(function (el) {
    return {
      el: el,
      start: parseFloat(el.dataset.start) || 0,
      end: parseFloat(el.dataset.end) || Infinity
    };
  });
  if (!cuepoints.length) return;

  var reducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* If video is hidden for reduced-motion users, we never get timeupdate.
     Pin the first cuepoint as a static overlay so the content still renders. */
  if (reducedMotion) {
    cuepoints[0].el.classList.add('is-active');
    return;
  }

  function tick() {
    var t = video.currentTime || 0;
    for (var i = 0; i < cuepoints.length; i++) {
      var cp = cuepoints[i];
      var active = t >= cp.start && t < cp.end;
      if (active !== cp.el.classList.contains('is-active')) {
        cp.el.classList.toggle('is-active', active);
      }
    }
  }

  /* timeupdate fires ~4 Hz — plenty for second-granularity chapter swaps. */
  video.addEventListener('timeupdate', tick);
  video.addEventListener('seeked', tick);
  video.addEventListener('play', tick);
  video.addEventListener('loadedmetadata', tick);

  /* Poster-period fallback: until the video starts playing, pin the first
     cuepoint so the overlay is never empty. Once timeupdate fires, tick()
     takes over. */
  if (video.readyState < 2 || video.paused) {
    cuepoints[0].el.classList.add('is-active');
  } else {
    tick();
  }
})();
